import { render } from "./DansukGoogleDrive.vue?vue&type=template&id=461157bc&scoped=true"
import script from "./DansukGoogleDrive.vue?vue&type=script&lang=js"
export * from "./DansukGoogleDrive.vue?vue&type=script&lang=js"

import "./DansukGoogleDrive.vue?vue&type=style&index=0&id=461157bc&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461157bc"]])

export default __exports__